import { defaultMomentDateFormat } from '@sit/core';
import { useGetUser } from '@sit/openapi';
import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';
/**
 * Converts an Intacct and moment date formats (all capitals, like `MM/DD/YYYY`) to a `date-fns` compatible format.
 * Replaces `Y` with `y` and `D` with `d`.
 */
export function toDateFnsFormat(intacctFormat) {
    return intacctFormat
        .replaceAll('Y', 'y')
        .replaceAll('D', 'd');
}
/**
 * Formats a date for Intacct based on the user's date format
 * @param dateOrDateString the date to format
 * @param dateFormat the `dateFormat` from `getUser().data.dateFormat`
 * @param options the `options` from `format`
 * @returns the formatted date
 */
export function formatIntacctDate(dateOrDateString, dateFormat, options) {
    // An example of the `format` parameter is `MM/DD/YYYY`
    // We use `date-fns` to format the date
    const date = typeof dateOrDateString === 'string'
        ? parse(dateOrDateString, 'yyyy-MM-dd', new Date())
        : dateOrDateString;
    return format(date, toDateFnsFormat(dateFormat), options);
}
/**
 * Gets the user's date format in a `date-fns` compatible format.
 * @param userData the user data from `getUser().data`
 * @returns the user's date format in a date-fns compatible input or a fallback if not found/not loaded
 */
export function getUserDateFormat(userData, fallback = defaultMomentDateFormat) {
    return toDateFnsFormat(userData?.dateFormat ?? fallback);
}
/**
 * Gets the user's date format in a `date-fns` compatible format.
 * @returns the user's date format or a fallback if not found/not loaded
 */
export function useUserDateFormat() {
    return getUserDateFormat(useGetUser().data);
}
//# sourceMappingURL=date.js.map